import clsx from "clsx";
import { motion } from "framer-motion";
import { ALL_USER_ICONS } from "../../helpers/user-icons";
import { ICON_SIZES } from "src/helpers/constants";
import Icon from "../Icon/Icon";
import CollapsibleBlock from "../CollapsibleBlock/CollapsibleBlock";

interface IIconSelector {
  onClick: (icon: string) => void;
  selected?: string;
  background?: string;
  color?: string;
  icons?: any[];
}

const IconSelector: React.FC<IIconSelector> = ({
  onClick,
  selected,
  background,
  color,
  icons = ALL_USER_ICONS,
}) => {
  const defaultBg = true ? "#22d3ee" : "#f87171";
  const defaultColor = true ? "white" : "white";

  return (
    <CollapsibleBlock title="Icono">
      <div className={clsx(["grid", "grid-cols-4", "md:grid-cols-7", "gap-2"])}>
        {icons?.map?.((icon: string) => {
          return (
            <motion.div
              key={icon}
              className={clsx([
                "flex",
                "items-center",
                "justify-center",
                "cursor-pointer",
                "rounded-md",
                "h-[60px]",
                "transition-colors",
                {
                  "text-gray-400": selected !== icon,
                  "hover:text-gray-500 hover:bg-gray-200": selected !== icon,
                },
              ])}
              style={{
                ...(selected === icon
                  ? background
                    ? { background }
                    : { background: defaultBg }
                  : {}),
                ...(selected === icon
                  ? color
                    ? { color }
                    : { color: defaultColor }
                  : {}),
              }}
              onClick={() => {
                if (selected === icon) {
                  onClick("");
                } else {
                  onClick(icon);
                }
              }}
              id={icon}
              whileTap={{ scale: 0.9 }}
              whileHover={{ scale: 1.05 }}
              transition={{
                type: "spring",
                stiffness: 400,
                damping: 17,
                duration: 0.3,
              }}
            >
              <Icon name={icon as any} size={ICON_SIZES.LG} />
            </motion.div>
          );
        }) || ""}
      </div>
    </CollapsibleBlock>
  );
};

export default IconSelector;
